import { render, staticRenderFns } from "./certFaceVerify.vue?vue&type=template&id=1d190175&"
import script from "./certFaceVerify.vue?vue&type=script&lang=js&"
export * from "./certFaceVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "certFaceVerify.vue"
export default component.exports